import React, { useState } from "react";
import styles from "./coursetabview.module.css";
import { FiChevronDown, FiChevronsLeft, FiChevronUp } from "react-icons/fi";
import { BiLeftArrow } from "react-icons/bi";
import { IoIosArrowForward } from "react-icons/io";
import Textfield from "../../components/Textfield";

const dummyData = [
  {
    title: "What all scanner systems training are included in the course?",
    description:
      "Currently, our Course provides training for ITero Scanner only, but we are working on developing Trios and Medit VR Training as well.",
  },
  {
    title: "What topics are covered in the VR course?",
    description:
      "We have Full Arch Scanning and Fixed Restoration Scanning VR Course available at this point. Denture Scanning workflow is under development.",
  },
  {
    title: "What is the difference between a “Try me” or “Test me” VR Course ?",
    description:
      'A "Try me" Course is a voice over guided instruction training which will guide you through every step as if you are performing a virtual hands-on training just like you perform a real-world hands-on experience under the guidance of a trainer. "Test me" Course is the next step in the journey of learning where there would be no instructions. You would need to perform the virtual hands-on based on which you will get a LIVE score on how well you understand the process.',
  },
  {
    title: "How can I buy these courses? ",
    description:
      "Once you pay through our website or through a payment link received via an email for the particular course, you will get the Virtual Headset delivered to you with then course as pre-installed and you can just connect the headset to WiFi and start learning.",
  },
];

const CourseQA = () => {
  return (
    <div className={styles.courseQA}>
      {dummyData.map((item, index) => (
        <AccordionItem key={index} item={item} />
      ))}
    </div>
  );
};

export default CourseQA;

const AccordionItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.accordionItem1}>
      <div className={styles.accordionHeader1} onClick={toggleAccordion}>
        <div className={styles.icon}>
          <IoIosArrowForward />
        </div>
        <Textfield type="h4" style={{ fontWeight: 600 }}>
          {item.title}
        </Textfield>
      </div>
      {isOpen && (
        <div className={styles.accordionContent1}>
          <Textfield type="span" style={{ fontWeight: 400, fontSize: 13 }}>
            {item.description}
          </Textfield>
        </div>
      )}
    </div>
  );
};
